export const SILENCE_WARNING_MS = 60_000;
export const SILENCE_ESCALATION_MS = 120_000;

export function silenceGuardState(lastSpeechAt: number, now = Date.now()): {
  phase: "recording" | "warning";
  secondsRemaining: number;
} {
  const silentFor = Math.max(0, now - lastSpeechAt);
  if (silentFor >= SILENCE_ESCALATION_MS) {
    return { phase: "warning", secondsRemaining: 0 };
  }
  if (silentFor >= SILENCE_WARNING_MS) {
    return {
      phase: "warning",
      secondsRemaining: Math.ceil((SILENCE_ESCALATION_MS - silentFor) / 1000)
    };
  }
  return { phase: "recording", secondsRemaining: 60 };
}

export class VoiceActivityDetector {
  private noiseFloor = 0.004;
  private sustainedSpeechMs = 0;

  observe(rms: number, durationMs: number): boolean {
    const safeRms = Number.isFinite(rms) ? Math.max(0, rms) : 0;
    const threshold = Math.max(0.012, this.noiseFloor * 3);
    if (safeRms >= threshold) {
      this.sustainedSpeechMs += Math.max(0, durationMs);
      if (this.sustainedSpeechMs >= 250) {
        this.sustainedSpeechMs = 0;
        return true;
      }
      return false;
    }
    this.sustainedSpeechMs = 0;
    this.noiseFloor = this.noiseFloor * 0.98 + safeRms * 0.02;
    return false;
  }

  reset() {
    this.noiseFloor = 0.004;
    this.sustainedSpeechMs = 0;
  }
}

export const activeElapsedMilliseconds = (
  startedAtMs: number,
  nowMs: number,
  accumulatedPausedMs: number,
  pausedAtMs = 0
) =>
  Math.max(
    0,
    nowMs -
      startedAtMs -
      accumulatedPausedMs -
      (pausedAtMs > 0 ? Math.max(0, nowMs - pausedAtMs) : 0)
  );
